var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVerified)?_c('svg',{staticClass:"verified-badge",attrs:{"aria-labelledby":"badgeTitle"}},[_c('title',{attrs:{"id":"badgeTitle"}},[_vm._v("Well Traveled Insider")]),_vm._v(" "),_c('use',{attrs:{"xlink:href":"#verified-badge"}},[_c('title',{attrs:{"id":"badgeTitle"}},[_vm._v("Well Traveled Insider")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }